import { Divider as DividerComponent } from 'antd';
import { DividerProps } from 'antd/lib/divider';
import { theme } from 'configs/styled';
import React from 'react';

const Divider: React.FC<DividerProps> = ({ ...props }) => {
  return (
    <DividerComponent
      {...props}
      style={{
        background: theme.palettes.grey97,
      }}
    />
  );
};

export default Divider;
